import React from 'react';
import { Button, Typography } from '@mui/material';

interface ButtonProps {
  className?: string;
  onClick?: () => void;
  text?: string;
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  children?: string;
  disabled?: boolean;
}

export const DefaultButton = ({
  className,
  children,
  onClick,
  text,
  icon,
  iconPosition = 'left',
  disabled,
}: ButtonProps) => (
  <Button
    variant="contained"
    className={className}
    onClick={onClick}
    style={{ gap: 8 }}
    disabled={disabled}
  >
    {iconPosition === 'left' ? icon : null}
    {text ? <Typography sx={{ fontSize: 12 }}>{text}</Typography> : children}
    {iconPosition === 'right' ? icon : null}
  </Button>
);
